import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';
import { WaitlistDialog } from '@/components/WaitlistDialog';

interface WaitlistContextValue {
  open: () => void;
}

const WaitlistContext = createContext<WaitlistContextValue | null>(null);

/**
 * Provides a single shared WaitlistDialog for the whole app.
 * Any component can call `useWaitlist().open()` to trigger it.
 */
export function WaitlistProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);

  return (
    <WaitlistContext.Provider value={{ open }}>
      {children}
      <WaitlistDialog open={isOpen} onOpenChange={setIsOpen} />
    </WaitlistContext.Provider>
  );
}

export function useWaitlist() {
  const ctx = useContext(WaitlistContext);
  if (!ctx) {
    throw new Error('useWaitlist must be used within a WaitlistProvider');
  }
  return ctx;
}
